import { ArrowRight } from "lucide-react";
import { HOME } from "../constants/testIds";
import Reveal from "../components/loadout/Reveal";
import Button from "../components/loadout/Button";
import { LAB_ARTICLES } from "../constants/business";

// [9] The Lab Teaser — 96px padding, canvas bg, three article cards.
export default function LabTeaser() {
  return (
    <section
      data-testid={HOME.labSection}
      className="bg-[#0A0A0A] text-white py-16 md:py-24"
    >
      <div className="mx-auto max-w-[1440px] px-6">
        <Reveal>
          <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-[#FF9F1C]">
            05 / OPERATOR LAB
          </div>
        </Reveal>
        <Reveal delay={60}>
          <h2 className="mt-4 font-display text-white text-[32px] md:text-[48px] leading-[0.95] max-w-[820px]">
            Field notes from the operator's bench.
          </h2>
        </Reveal>
        <Reveal delay={120}>
          <p className="mt-4 font-sans text-[16px] text-[#8A8A8A] max-w-[620px] leading-relaxed">
            Long-form buyer guides, comparison articles, verified benchmarks.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {LAB_ARTICLES.map((a, i) => (
            <Reveal key={a.title} delay={60 * i}>
              <a
                data-testid={HOME.labArticle}
                href={a.href}
                className="group relative block bg-[#141414] border border-[#1F1F1F] p-6 hover:border-[#FF9F1C] transition-colors h-full"
              >
                <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-[#FF9F1C]">
                  {a.category}
                </div>
                <h3 className="mt-6 font-display text-white text-[22px] md:text-[24px] leading-[1.05] min-h-[64px]">
                  {a.title}
                </h3>
                <p className="mt-4 font-sans text-[15px] text-[#8A8A8A] leading-relaxed line-clamp-2">
                  {a.excerpt}
                </p>
                <div className="mt-6 flex items-center gap-2 text-white/80 group-hover:text-[#FF9F1C] transition-colors">
                  <span className="font-sans text-[12px] uppercase tracking-[0.04em] font-semibold">
                    Read
                  </span>
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 flex justify-start">
          <Button
            as="a"
            href="/operator-lab"
            variant="secondaryDark"
            data-testid={HOME.labCta}
          >
            Open The Lab →
          </Button>
        </div>
      </div>
    </section>
  );
}
